import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { addNewMaintenanceCompany, getMaintenanceCompanyList, updateMaintenanceCompany } from '../../../../slices/maintenanceCompany/thunk';
import { setRequireCloseModal } from '../../../../slices/maintenanceCompany/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import OInput from '../../../../Components/OElements/OInput';

const MaintenanceCompanyForm = ({
	dataMaintenanceCompany,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
}) => {
	const dispatch = useDispatch();

	const selectorMaintenanceCompany = createSelector(
		state => state.MaintenanceCompany,
		maintenanceCompany => ({
			isAdding: maintenanceCompany.isAdding,
			isAdded: maintenanceCompany.isAdded,
			isUpdating: maintenanceCompany.isUpdating,
			isUpdated: maintenanceCompany.isUpdated,
			isLoadingList: maintenanceCompany.isLoadingList,
			requireCloseModal: maintenanceCompany.requireCloseModal,
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorMaintenanceCompany);

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			name: (dataMaintenanceCompany && dataMaintenanceCompany.name) || '',
			mail: (dataMaintenanceCompany && dataMaintenanceCompany.mail) || '',
			disabled: (dataMaintenanceCompany && dataMaintenanceCompany.disabled) || false,
		},
		validationSchema: Yup.object({
			name: Yup.string().required('Campo requerido'),
			mail: Yup.string().required('Campo requerido'),
		}),
		onSubmit: values => { 
			if (isEdit) {
				const updatedMaintenanceCompany = {
					_id: dataMaintenanceCompany._id,
					name: values.name,
					mail: values.mail,
					disabled: values.disabled
				};
				dispatch(updateMaintenanceCompany(updatedMaintenanceCompany));
			} else {
				const newMaintenanceCompany = {
					name: values.name,
					mail: values.mail,
					disabled: values.disabled
				};
				dispatch(addNewMaintenanceCompany(newMaintenanceCompany));
			}
			dispatch(getMaintenanceCompanyList());
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col lg={6}>
								<OInput
									name='name'
									label='Nombre de la Empresa de Mantenimiento'
									type='text'
									validation={validation}
									isRequired={true}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
							<Col lg={6}>
								<OInput
									name='mail'
									label='Correo Electrónico'
									type='text'
									validation={validation}
									isRequired={true}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isAdding || isUpdating}
					>
						{isAdding || isUpdating ? (
							<i className='label-icon'><Spinner size='sm' /></i>
						) : <i className="ri-save-3-line label-icon"></i>}
						{isEdit ? 'Editar' : 'Crear'} Empresa de Mantenimiento
					</button>
				</div>
			</div>
		</Form>
	);
};

export default MaintenanceCompanyForm;
